import React from 'react';

type Props = {
	className?: string;
};

const IconCameraEvents = ({ className = '' }: Props) => {
	return (
		<span className={`icon-camera-event ${className}`}>
			<span className="path1"></span>
			<span className="path2"></span>
			<span className="path3"></span>
			<span className="path4"></span>
			<span className="path5"></span>
			<span className="path6"></span>
			<span className="path7"></span>
			<span className="path8"></span>
			<span className="path9"></span>
			<span className="path10"></span>
			<span className="path11"></span>
			<span className="path12"></span>
			<span className="path13"></span>
			<span className="path14"></span>
			<span className="path15"></span>
			<span className="path16"></span>
			<span className="path17"></span>
			<span className="path18"></span>
			<span className="path19"></span>
			<span className="path20"></span>
			<span className="path21"></span>
			<span className="path22"></span>
			<span className="path23"></span>
			<span className="path24"></span>
			<span className="path25"></span>
			<span className="path26"></span>
			<span className="path27"></span>
			<span className="path28"></span>
			<span className="path29"></span>
			<span className="path30"></span>
			<span className="path31"></span>
			<span className="path32"></span>
			<span className="path33"></span>
			<span className="path34"></span>
			<span className="path35"></span>
			<span className="path36"></span>
			<span className="path37"></span>
			<span className="path38"></span>
			<span className="path39"></span>
			<span className="path40"></span>
			<span className="path41"></span>
			<span className="path42"></span>
			<span className="path43"></span>
			<span className="path44"></span>
			<span className="path45"></span>
			<span className="path46"></span>
			<span className="path47"></span>
			<span className="path48"></span>
			<span className="path49"></span>
			<span className="path50"></span>
			<span className="path51"></span>
			<span className="path52"></span>
			<span className="path53"></span>
			<span className="path54"></span>
			<span className="path55"></span>
			<span className="path56"></span>
			<span className="path57"></span>
			<span className="path58"></span>
			<span className="path59"></span>
			<span className="path60"></span>
			<span className="path61"></span>
			<span className="path62"></span>
			<span className="path63"></span>
			<span className="path64"></span>
			<span className="path65"></span>
			<span className="path66"></span>
			<span className="path67"></span>
			<span className="path68"></span>
			<span className="path69"></span>
			<span className="path70"></span>
			<span className="path71"></span>
			<span className="path72"></span>
			<span className="path73"></span>
			<span className="path74"></span>
			<span className="path75"></span>
			<span className="path76"></span>
			<span className="path77"></span>
			<span className="path78"></span>
			<span className="path79"></span>
			<span className="path80"></span>
			<span className="path81"></span>
			<span className="path82"></span>
			<span className="path83"></span>
			<span className="path84"></span>
			<span className="path85"></span>
			<span className="path86"></span>
			<span className="path87"></span>
			<span className="path88"></span>
			<span className="path89"></span>
			<span className="path90"></span>
			<span className="path91"></span>
			<span className="path92"></span>
			<span className="path93"></span>
			<span className="path94"></span>
			<span className="path95"></span>
			<span className="path96"></span>
			<span className="path97"></span>
			<span className="path98"></span>
			<span className="path99"></span>
			<span className="path100"></span>
			<span className="path101"></span>
			<span className="path102"></span>
			<span className="path103"></span>
			<span className="path104"></span>
			<span className="path105"></span>
			<span className="path106"></span>
			<span className="path107"></span>
			<span className="path108"></span>
			<span className="path109"></span>
			<span className="path110"></span>
			<span className="path111"></span>
			<span className="path112"></span>
			<span className="path113"></span>
			<span className="path114"></span>
			<span className="path115"></span>
			<span className="path116"></span>
			<span className="path117"></span>
			<span className="path118"></span>
			<span className="path119"></span>
			<span className="path120"></span>
			<span className="path121"></span>
			<span className="path122"></span>
			<span className="path123"></span>
			<span className="path124"></span>
			<span className="path125"></span>
			<span className="path126"></span>
			<span className="path127"></span>
			<span className="path128"></span>
			<span className="path129"></span>
			<span className="path130"></span>
			<span className="path131"></span>
			<span className="path132"></span>
			<span className="path133"></span>
			<span className="path134"></span>
			<span className="path135"></span>
			<span className="path136"></span>
			<span className="path137"></span>
			<span className="path138"></span>
			<span className="path139"></span>
			<span className="path140"></span>
			<span className="path141"></span>
			<span className="path142"></span>
			<span className="path143"></span>
			<span className="path144"></span>
			<span className="path145"></span>
			<span className="path146"></span>
			<span className="path147"></span>
			<span className="path148"></span>
			<span className="path149"></span>
			<span className="path150"></span>
			<span className="path151"></span>
			<span className="path152"></span>
			<span className="path153"></span>
			<span className="path154"></span>
			<span className="path155"></span>
			<span className="path156"></span>
		</span>
	);
};

export default IconCameraEvents;
